import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { forkJoin, concat, of } from "rxjs";
import { switchMap, catchError } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { Globals } from "../globals";
import { ImageUploadDialogComponent } from "../image-upload-dialog/image-upload-dialog.component";
import { ProductContent } from "../_models/product-content";
import { ProductPrice } from "../_models/product-price";
import { Product } from "../_models/product";
import _ from "lodash";
import { CountryService } from "../_services/country.service";
import { Country } from "../_models/country";

@Component({
  selector: "app-view-country-page",
  templateUrl: "./view-country-page.component.html",
  styleUrls: ["./view-country-page.component.scss"],
})
export class ViewCountryPageComponent implements OnInit {
  public categories = new FormControl();
  public isDataLoaded = false;
  public isModified = false;
  public newProductContent = new ProductContent();
  public country: Country;
  public showAddContents = false;
  public currencies = ["PHP", "USD"];

  constructor(
    private activatedRoute: ActivatedRoute,
    public countryService: CountryService,
    public globals: Globals,
    private location: Location,
    public snackBar: MatSnackBar,
    public uploadDialog: MatDialog,
    private router: Router
  ) {}

  public activate(): void {
    this.country.active = true;
    this.save();
  }

  public back(): void {
    this.location.back();
  }

  public cancel(): void {
    this.refresh();
  }

  public dataChanged(): void {
    this.isModified = true;
  }

  public deactivate(): void {
    this.country.active = false;
    this.save();
  }

  public delete() {
    this.countryService.deleteCountry(this.country.id).subscribe(
      (res) => {
        this.router.navigate(["regional", "country"]);
      },
      (err) => {
        console.error(err);
        this.showErrorMessage(
          "Sorry, your request cannot be process at the moment!"
        );
      }
    );
  }

  public getImageUrl(): string {
    return environment.imageUrl;
  }

  public loadData(countryId: number) {
    this.countryService.getCountry(countryId).subscribe(
      (country) => {
        this.country = country;
        this.isDataLoaded = true;
        this.isModified = false;
      },
      (err) => {
        if (err.status == 404) {
          this.isDataLoaded = true;
          this.showErrorMessage("Country not found");
        }
      }
    );
  }

  public ngOnInit(): void {
    this.activatedRoute.paramMap
      .pipe(
        switchMap((params: ParamMap) => {
          const countryId = params.get("id");
          if (!this.globals.isNullOrEmpty(countryId)) {
            this.loadData(parseInt(countryId, 10));
          } else {
            this.showErrorMessage("Please specify the country Id!");
          }

          return Promise.resolve();
        })
      )
      .subscribe();
  }

  public refresh(): void {
    this.isDataLoaded = false;
    this.loadData(this.country.id);
  }

  isCountryValid() {
    return this.country.name && this.country.code;
  }

  public save(): void {
    if (!this.isCountryValid()) {
      this.showErrorMessage("Name or code is required");
      return;
    }

    this.countryService.updateCountry(this.country).subscribe(
      (res) => {
        this.refresh();
      },
      (err) => {
        console.error(err);
        this.showErrorMessage(
          "Sorry, your request cannot be process at the moment!"
        );
      }
    );
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }

  public updateList(price: ProductPrice, propertys: string, value: any) {
    console.log(value);
  }
}
